import { Star } from "lucide-react";

type StarRatingProps = {
  rating: number;
  max?: number;
  showNumber?: boolean;
  size?: "sm" | "md";
};

export function StarRating({
  rating,
  max = 5,
  showNumber = true,
  size = "sm",
}: StarRatingProps) {
  const filled = Math.min(max, Math.max(0, rating));
  const empty = max - filled;
  const iconSize = size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";

  return (
    <span className="inline-flex items-center gap-0.5">
      {Array.from({ length: filled }).map((_, i) => (
        <Star
          key={`filled-${i}`}
          className={`${iconSize} fill-current text-foreground`}
          aria-hidden
        />
      ))}
      {Array.from({ length: empty }).map((_, i) => (
        <Star
          key={`empty-${i}`}
          className={`${iconSize} text-muted-foreground`}
          aria-hidden
        />
      ))}
      {showNumber && (
        <span className="ml-1 text-muted-foreground text-sm">({rating})</span>
      )}
    </span>
  );
}
